import CreateProposal from '@/pages/proposal/create-proposal/CreateProposal';
import ProposalTable from '@/pages/proposal/view-proposal/ProposalTable';

const proposalRoutes = [
  { path: 'createquote/:proposalId', element: CreateProposal },
  { path: 'vieweditquote', element: ProposalTable },
];

export default proposalRoutes;
